import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const DocumentsSectionStyled = styled.section`
  margin: 0 auto;
`;

export const StyledListWrapper = styled.ul`
  list-style: none;
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 5rem 4rem;
  box-sizing: border-box;
  position: relative;
  margin: 0 auto;
  min-height: 24rem;
`;

export const InactiveSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 7rem auto 2.5rem;
`;

export const InactiveListTitleStyled = styled.h3`
  margin: 0;
  font-size: 1.8rem;
  line-height: 2.8rem;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  color: ${colors.neutral[700]};
`;

export const InactiveListCaptionStyled = styled.p`
  margin: 0;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: ${colors.neutral[700]};
`;
